import {createContext, useEffect, useState} from 'react';
import {Login} from "./pages/login/Login";
import "./styles/style.scss"
import "./styles/Calibri/stylesheet.css"
import {PopupList} from "./components/popup/PopupList";
import {Sprites} from "./components/sprites/Sprites";
import {Wrapper} from "./components/wrapper/Wrapper";
import {Navigate, Route, Routes, useLocation, useNavigate} from 'react-router-dom';
import {Timesheet} from "./pages/timesheet/Timesheet";
import {Employees} from "./pages/employees/Employees";
import {useDispatch, useSelector} from 'react-redux';
import {getBearer} from "./functions/getBearer";
import axios from "axios";
import {getApiLink} from "./functions/getApiLink";
import {Projects} from "./pages/projects/Projects";
import {AppStyled} from "./App.styled";
import {Vacations} from "./pages/vacations/Vacations";
import {Costs} from "./pages/costs/Costs";
import {Summary} from "./pages/summary/Summary";
import {SummaryEmployees} from "./pages/summaryEmployees/SummaryEmployees";
import getCookies from "./functions/getCookie";
import {ITimesheet, IUser} from "./models";
import {ResetPassword} from "./pages/resetPassword/ResetPassword";
import {SetNotifications} from "./api/SetNotifications";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {GetAccessToken} from "./api/GetAccessToken";
import {SetTasks} from "./api/SetTasks";
import {SetExpenses} from './api/SetExpenses';
import {setProjects, setUser} from './storage/toolkit';
import getCookie from "./functions/getCookie";
import {isPublicPath} from "./functions/publicRoutes";
import {SetAllUserProjects} from "./api/SetAllUserProjects";
import { Analytics } from './pages/analytics/Analytics';
import { GlobalProvider } from './GlobalContext';
import { access_token, refresh_token } from './api/CookieKeys';


export const PopupContext: any = createContext(null)

function App() {

    function setZoom() {
        if (window.matchMedia('(min-width: 1200px) and (max-width: 1500px)').matches) {
            // @ts-ignore
            if (document.querySelector(".main__inner section")) {
                // @ts-ignore
                document.querySelector(".main__inner section").style.zoom = "70%";
                // @ts-ignore
                document.querySelector(".main__inner section").style.minHeight = "calc(140vh - 60px)";

                if (document.querySelector(".down-sidebar")) {
                    // @ts-ignore
                    document.querySelector(".main__inner section").style.paddingBottom = "110px"
                } else {
                    // @ts-ignore
                    document.querySelector(".main__inner section").style.paddingBottom = "0px"
                }

            }
        } else {
            // @ts-ignore
            document.body.style.zoom = "100%";
            if (document.querySelector(".main__inner section")) {
                // @ts-ignore
                document.querySelector(".main__inner section").style.zoom = "100%";
                // @ts-ignore
                document.querySelector(".main__inner section").style.minHeight = "calc(95vh - 4px)";

                if (document.querySelector(".down-sidebar")) {

                    if (window.innerWidth < 576) {
                        // @ts-ignore
                        document.querySelector(".main__inner section").style.paddingBottom = "60px"
                    } else {
                        // @ts-ignore
                        document.querySelector(".main__inner section").style.paddingBottom = "80px"
                    }

                } else {
                    // @ts-ignore
                    document.querySelector(".main__inner section").style.paddingBottom = "0px"
                }

            }
        }
    }

    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation()

    const userData: IUser = useSelector((state: any) => state.toolkit.user)
    const chosenTimesheet: ITimesheet = useSelector((state: any) => state.toolkit.chosenTimesheet)
    const timesheet: ITimesheet[] = useSelector(
        (state: any) => state.toolkit.timesheet
      );

    useEffect(() => {

        getProfile()

        window.addEventListener('resize', setZoom);
    }, [])

    useEffect(() => {
        if (!userData?.id) return;

        if (!getCookies(access_token) && !location.pathname.includes("reset-password")) {
            return navigate("/login");
        } else if (location.pathname.includes("login")) {
            navigate("/");
        } else if (location.pathname.includes("reset-password")) {
            // Someone signed in may still follow a reset link; leave them on it
            return;
        }

        // A password issued by somebody else has to be replaced before
        // anything else loads. The API refuses every other endpoint while the
        // flag is set, so fetching here would only produce a screenful of
        // failed requests behind a screen the user cannot leave anyway.
        if (userData?.must_change_password) {
            if (!location.pathname.includes("change-password")) navigate("/change-password");
            return;
        }

        if (userData?.role === "admin") {
            getBearer('get')
            axios.get(getApiLink("/api/admin/project/")).then(({data}) => {
                dispatch(setProjects(data))
            }).catch(er => console.log(getApiLink("api/admin/project/"), er))
        } else {
            SetTasks(dispatch, chosenTimesheet?.id)
            SetExpenses(dispatch, chosenTimesheet?.id)
            // SetTimesheet(dispatch)
            SetNotifications(dispatch)
            // SetSummaryEmployees(dispatch)
            SetAllUserProjects(dispatch, chosenTimesheet)
        }


    }, [userData])

    useEffect(() => {
        SetAllUserProjects(dispatch, chosenTimesheet)
    }, [chosenTimesheet])

    const getProfile = () => {
        // The reset-password link is opened by someone who cannot sign in, so
        // a missing token is expected there and must not bounce them to login.
        if (!getCookie(access_token)) {
            if (!isPublicPath(location.pathname)) navigate("/login");
            return;
        }

        getBearer('get')
        axios.get(getApiLink("/api/user/profile/")).then(({data}) => {
            dispatch(setUser(data))
        }).catch(er => {
            console.log(er)
            if (getCookie(access_token) && getCookie(refresh_token)) {
                GetAccessToken(dispatch, getProfile)
            } else {
                return er?.response?.status === 401 && GetAccessToken(dispatch, getProfile)
            }
        })
    }


    useEffect(() => {
        setZoom();
    }, [location.pathname])


    const [popup, setPopup] = useState({
        popup: '',
        data: null
    })

    const isAdmin = (userData?.status ?? '').includes("admin")
    const isEmployee = (userData?.status ?? '').includes("employee")
    const isManager = (userData?.status ?? '').includes("team_lead") || (userData?.status ?? '').includes("project_lead")

    // Removed incorrect auto-redirect: routing / login is handled elsewhere
    // useEffect(() => {
    //     if (!userData.id) return;
    //     navigate("/login")
    // }, [])

    // Decided during render, not in an effect. The effect above only re-runs
    // when `userData` changes, so pressing the browser's Back button - which
    // changes the location and nothing else - used to leave the whole app
    // shell on screen for an account that is supposed to be held on the
    // change-password screen. Every endpoint answered 403, so there was
    // nothing to read, but sitting inside the app at all is not a state to
    // allow. Rendering `Navigate` instead of the app makes the route
    // unreachable rather than merely unhelpful.
    const PASSWORD_SCREENS = ['change-password', 'login', 'reset-password']
    const isHeldForPasswordChange = !!userData?.must_change_password
        && !PASSWORD_SCREENS.some(screen => location.pathname.includes(screen))

    return (
        <AppStyled>
            <PopupContext.Provider value={setPopup}>
                <Sprites/>
                <PopupList popup={popup}/>


                {isHeldForPasswordChange ? <Navigate to={"/change-password"} replace/> :
                <GlobalProvider>
                    <Wrapper>
    
                        <Routes location={location}>
    
                            <Route path={'/costs'} element={<Costs/>}/>
                            <Route path={'/expenses/:timesheetId'} element={<Costs/>}/>
                            <Route path={"/"} element={isAdmin ? <Employees/> : <Timesheet/>}/>
                            <Route path={"/timesheet"} element={<Timesheet/>}/>
                            <Route path={"/iC"} element={isAdmin ? <Employees/> : <Timesheet/>}/>
                            <Route path={"/timesheet/:timesheetId"} element={<Timesheet/>}/>
                            <Route path={'/summary-employees'} element={<SummaryEmployees/>}/>
                            <Route path={'/summary'} element={<Summary/>}/>
                            <Route path={'/vacations'} element={<Vacations/>}/>
                            <Route path={'/projects'} element={<Projects/>}/>
                            <Route path={"/employees"} element={<Employees/>}/>
                            <Route path={'/login'} element={<Login/>}/>
                            <Route path={'/reset-password/:userCode/:userEmail'} element={<ResetPassword/>}/>
                            {/* Same screen, no code in the URL: the visitor is
                                already signed in and is replacing a password
                                that was issued to them. */}
                            <Route path={'/change-password'} element={<ResetPassword/>}/>
                            <Route path={'/analytics'} element={<Analytics/>}/>
    
                        </Routes>
    
                    </Wrapper>
                </GlobalProvider>}

                <ToastContainer/>

            </PopupContext.Provider>
        </AppStyled>
    );
}

export default App;
